const values = {
  agreementAge: 14,
};
export default values;
